/**
 * Prefetch binaires /uploads (docs client, etc.) — GO_OFFLINE_CLIENT_DOCS
 * Réutilise le cache SW `ucp-uploads-v1`.
 */
export const UPLOADS_CACHE_NAME = 'ucp-uploads-v1';

export function toUploadsCacheKeyUrl(urlOrPath) {
  if (typeof window === 'undefined') return '';
  let path = String(urlOrPath || '').trim();
  if (!path) return '';
  try {
    if (path.includes('://')) {
      path = new URL(path).pathname;
    } else {
      path = path.split('?')[0];
    }
  } catch {
    path = path.split('?')[0];
  }
  if (!path.startsWith('/')) path = `/${path}`;
  if (!path.startsWith('/uploads/')) return '';
  return `${window.location.origin}${path.replace(/\/+$/, '')}`;
}

export async function matchUploadsCache(urlOrPath) {
  const keyUrl = toUploadsCacheKeyUrl(urlOrPath);
  if (!keyUrl || typeof caches === 'undefined') return null;
  try {
    const cache = await caches.open(UPLOADS_CACHE_NAME);
    return (
      (await cache.match(keyUrl, { ignoreSearch: true }))
      || (await cache.match(new Request(keyUrl), { ignoreSearch: true }))
    );
  } catch {
    return null;
  }
}

/** Prefetch same-origin → Cache API uploads. */
export async function warmUploadsUrl(urlOrPath) {
  if (typeof window === 'undefined' || typeof fetch !== 'function') return false;
  const keyUrl = toUploadsCacheKeyUrl(urlOrPath);
  if (!keyUrl) return false;
  const existing = await matchUploadsCache(keyUrl);
  if (existing) return true;
  try {
    const response = await fetch(keyUrl, {
      method: 'GET',
      credentials: 'include',
      cache: 'no-store'
    });
    if (!response.ok) return false;
    const cache = await caches.open(UPLOADS_CACHE_NAME);
    await cache.put(keyUrl, response.clone());
    return true;
  } catch {
    return false;
  }
}

export function extractClientDocumentRows(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.documents)) return payload.documents;
  return [];
}
